import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-statistik-normtid-options',
    templateUrl: './statistik-normtid-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikNormtidOptionsComponent {
    @Input() periode: string;
    @Output() periodeChange = new EventEmitter<string>();
    @Output() exportExcel = new EventEmitter();
    @Output() selectDeciminuts = new EventEmitter<boolean>();
    @Output() selectDecimal = new EventEmitter<number>();
    @Output() selectGruppe = new EventEmitter<string>();
    inDeciminutes: boolean;
    selectedDecimal = 2;
    decimals = [0, 1, 2];

    onPeriodeChange(periode: string, isValidDate: boolean) {
        if (!isValidDate || periode === '') { return; }
        this.periodeChange.emit(periode);
    }

    onSelectDeciminuts(deciminuts: boolean) {
        this.selectDeciminuts.emit(deciminuts);
    }

    onSelectDecimal(decimals: number | null) {
        this.selectedDecimal = decimals;
        this.selectDecimal.emit(decimals);
    }

    onSelectGruppe(gruppe: string) {
        this.selectGruppe.emit(gruppe);
    }

    onExportExcel() {
        this.exportExcel.emit();
    }
}
